import { Route, Routes } from "react-router-dom";
import PrivateRoutes from "./PrivateRoutes";
import PublicRoutes from "./PublicRoutes";
import SignIn from "../pages/auth/SignIn";
import VerifyOtp from "../pages/auth/VerifyOtp";
import SetPassword from "../pages/auth/SetPassword";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import Home from "../pages/Home";
import World from "../pages/world/World";
import RmcLandingPage from "../pages/world/rmc/RmcLandingPage";
import WorldHome from "../pages/world/rmc/Home";
import WorldRules from "../pages/world/rmc/Rules";
import WorldLive from "../pages/world/rmc/Live";
import WorldProfile from "../pages/world/rmc/Profile";
import RmcTrivia from "../pages/world/rmc/TriviaQuestions";
import WorldAchievements from "../pages/world/rmc/Achievements";
import { Eligibility } from "../modules/world/rmc/achievements/rewards/rewardEligibility/eligibility";
import { RewardTracking } from "../modules/world/rmc/achievements/rewards/rewardEligibility/rewardTracking";
import { RmcCardTopUp } from "../modules/world/rmc/achievements/wallet/fundWallet/cardTopUp";
import Gaming from "../pages/Gaming";
import Settings from "../pages/Settings";
import { FundWallet } from "../modules/wallet/fundWallet/fundWallet";
import { BankTransfer } from "../modules/wallet/fundWallet/bankTransfer";
import { CardTopUp } from "../modules/wallet/fundWallet/cardTopup";
import { CofirmCardDetails } from "../modules/wallet/fundWallet/confirmCardDetails";
import { Ussd } from "../modules/wallet/fundWallet/ussd";
import { WithdrawIndex } from "../modules/wallet/withdraw/withdrawIndex";
import { SavedAccount } from "../modules/wallet/withdraw/savedAccount";
import { Swap } from "../modules/wallet/swap/Swap";
import { PaymentDetails } from "../components/userSetting/PaymentDetails";
import { ReferAndEarn } from "../components/userSetting/ReferAndEarn";
import UserProfile from "../components/userSetting/UserProfile";
import Help from "../pages/Help";
import Achievements from "../pages/Achievements";
import { RedeemPoints } from "../modules/redeem/redeemPoints";
import { RedeemSuccess } from "../modules/redeem/reddemSuccess";
import Wallet from "../pages/Wallet";
import ChangePassword from "../components/userSetting/ChangePassword";
import TransactionPin from "../components/userSetting/TransactionPin";
import ChangeTransactionPin from "../components/userSetting/TransactionPin/ChangePin";
import ForgotTransactionPin from "../components/userSetting/TransactionPin/ForgotPin";
import Campaigns from "../pages/Campaigns";
import PreGame from "../pages/PreGame";
import GameScreen from "../pages/GameScreen/GameScreen";
import { forwardRef, useContext, useState } from "react";
import { UserContext } from "../components/context/UseContext";
import RmcContextWrapper from "../components/context/RmcContextWrapper";
import GamingCategory from "../modules/gamingCategories";

const AppRoutes = forwardRef((props, audioRef) => {
  const { token } = useContext(UserContext);
  const [isPlaying, setIsPlaying] = useState(false);

  const playSound = () => {
    const audioElement = audioRef.current;

    if (audioElement) {
      audioElement
        .play()
        .then(() => {
          setIsPlaying(true);
        })
        .catch((error) => {
          console.error("Autoplay was prevented", error);
        });
    }
  };

  const stopSound = () => {
    audioRef.current.pause();
    setIsPlaying(false);
  };

  const trickPlay = () => {
    playSound();
  };

  return (
    <Routes>
      <Route element={<PublicRoutes />}>
        <Route path="/" element={<SignIn replace />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/setup-password" element={<SetPassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Route>
      <Route element={<PrivateRoutes isAuthenticated={token ? true : false} />}>
        <Route element={<RmcContextWrapper />}>
          <Route path="/home" element={<Home />} />
          <Route path="/worlds" element={<World />} />
          <Route path="/worlds/:id" element={<RmcLandingPage />} />
          <Route path="/worlds/:id/home" element={<WorldHome />} />
          <Route path="/worlds/:id/rules" element={<WorldRules />} />
          <Route path="/worlds/:id/live" element={<WorldLive />} />
          <Route path="/worlds/:id/profile" element={<WorldProfile />} />
          <Route path="/worlds/:id/questions" element={<RmcTrivia />} />

          <Route
            path="/worlds/:id/achievements"
            element={<WorldAchievements />}
          />
          <Route
            path="/worlds/:id/achievements/rewards/eligibility"
            element={<Eligibility />}
          />
          <Route
            path="/worlds/:id/achievements/rewards/tracking"
            element={<RewardTracking />}
          />
          <Route
            path="/worlds/:id/achievements/fund-wallet"
            element={<RmcCardTopUp />}
          />
          <Route path="/search" element={<Gaming />} />
          <Route path="/search/category/:id" element={<GamingCategory />} />
        </Route>
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/wallet/fund" element={<FundWallet />} />
        <Route
          path="/settings/wallet/fund/bank-transfer"
          element={<BankTransfer />}
        />
        <Route
          path="/settings/wallet/fund/card-topup"
          element={<CardTopUp />}
        />
        <Route
          path="/settings/wallet/fund/card-topup/confirm"
          element={<CofirmCardDetails />}
        />
        <Route path="/settings/wallet/fund/ussd" element={<Ussd />} />
        <Route path="/settings/wallet/withdraw" element={<WithdrawIndex />} />
        <Route
          path="/settings/wallet/withdraw/saved"
          element={<SavedAccount />}
        />
        <Route path="/settings/wallet/swap" element={<Swap />} />
        <Route path="/settings/payment-details" element={<PaymentDetails />} />
        <Route path="/settings/refer-and-earn" element={<ReferAndEarn />} />
        <Route
          path="/settings/profile"
          element={<UserProfile play={trickPlay} stop={stopSound} />}
        />
        <Route path="/settings/help" element={<Help />} />
        <Route path="/achievements" element={<Achievements />} />
        <Route path="/achievements/redeem-points" element={<RedeemPoints />} />
        <Route
          path="/achievements/redeem-success"
          element={<RedeemSuccess />}
        />
        <Route path="/settings/wallet" element={<Wallet />} />
        <Route
          path="/settings/secure/change-password"
          element={<ChangePassword />}
        />
        <Route
          path="/settings/secure/transaction-pin"
          element={<TransactionPin />}
        />
        <Route
          path="/settings/secure/transaction-pin/change"
          element={<ChangeTransactionPin />}
        />
        <Route
          path="/settings/secure/transaction-pin/forgot"
          element={<ForgotTransactionPin />}
        />
        <Route path="/campaign_id/:id" element={<Campaigns />} />
        <Route path="/campaign_id/:id/game_id/:id" element={<PreGame />} />
        <Route
          path="/game-started"
          element={
            <GameScreen
              isPlaying={isPlaying}
              play={trickPlay}
              stop={stopSound}
            />
          }
        />
      </Route>
    </Routes>
  );
});

export default AppRoutes;
